import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { Namespace } from '../../../translation/namespace';

export type PageTypeValidityPeriodDefaultViewProps = {
  maxValidityPeriodDays: number;
};
export function PageTypeValidityPeriodDefaultView({ maxValidityPeriodDays }: PageTypeValidityPeriodDefaultViewProps) {
  const { t } = useTranslation(Namespace.PageTypeValidityPeriod);

  const validationPeriod =
    maxValidityPeriodDays === 0 ? t('validity.unlimited') : t('validity.inDays', { maxValidityPeriodDays });

  return <ContentMessage text={validationPeriod} />;
}
